<template>
	<div>
		<div class="d-flex flex-row align-center justify-space-between my-2 mb-0 px-4">
			<p class="mb-0 font-weight-bold body-2" style="color: #524D4D">Tipos de Estructura</p>
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon color="grey" class="mr-3"
						v-bind="attrs"
						v-on="on"
						small
						v-if="$checkPermissions(['create_company_materials'])"
						@click="openModal(null)">
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</template>
				<span>Nuevo Tipo de Estructura</span>
			</v-tooltip>
		</div>
		<v-divider class="my-2"></v-divider>
		<v-list class="pt-0" style="max-height: 300px;overflow: scroll;" v-if="materials.length > 0">
			<v-list-item class="px-0 py-0">
				<div style="width: 100%">
					<div class="d-flex flex-row px-4 justify-space-between align-center" style="gap: 15px;">
						<div class="d-flex flex-1 align-center justify-space-between">
							<div class="px-4 caption">
								<p class="mb-0 caption font-weight-bold" style="color: #999999;">Estructura</p>
							</div>
							<div class="caption font-weight-bold" style="color: #999999;">
								Valor X M2
							</div>
						</div>
						<v-divider class="mx-2" vertical style="opacity:0;"></v-divider>
						<div style="width: 50px;">
						</div>
					</div>
				</div>
			</v-list-item>
			<v-list-item
				v-for="(item, i) in materials"
				:key="i"
				class="px-0 py-0"
			>
				<div style="width: 100%">
					<div class="d-flex flex-row px-4 justify-space-between align-center" style="gap: 15px;">
						<div class="d-flex flex-1 align-center justify-space-between">
							<div class="px-4 caption">
								<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.name }}</p>
							</div>
							<div class="caption font-weight-bold" style="color: #707070;">
								{{ item.uf_value || '0' }}
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div style="width: 50px;">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="warning"
										v-if="$checkPermissions(['edit_company_materials'])"
										@click="openModal(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-pencil</v-icon>
									</v-btn>
								</template>
								<span>Editar Tipo de Estructura</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="error"
										v-if="$checkPermissions(['delete_company_materials'])"
										@click="deleteMaterial(item)"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-delete-outline</v-icon>
									</v-btn>
								</template>
								<span>Eliminar Tipo de Estructura</span>
							</v-tooltip>
						</div>
					</div>
				</div>
			</v-list-item>
		</v-list>
		<div v-else class="px-4 py-3">
			<p class="mb-0 caption" style="color: #999999;">No hay tipos de estructura registrados</p>
		</div>

		<!-- Modal para crear/editar -->
		<v-dialog v-model="dialog" max-width="600px">
			<v-card>
				<v-card-title style="background-color: #524D4D; color: white;">
					{{ editingMaterial ? 'Editar Tipo de Estructura' : 'Nuevo Tipo de Estructura' }}
				</v-card-title>
				<v-card-text class="pt-4">
					<v-form ref="form" v-model="validForm">
						<div class="d-flex" style="gap: 15px;">
							<v-text-field
								v-model="formData.name"
								label="Nombre"
								outlined
								required
								dense
								hide-details
								class="custom-height-search custom-height-calendar mt-3"
								:rules="requiredRule"
							/>
							<v-text-field
								v-model="formData.uf_value"
								type="number"
								label="Valor x M2 (UF)"
								outlined
								required
								dense
								hide-details
								class="custom-height-search custom-height-calendar mt-3"
								style="font-size: 14px;"
								:rules="requiredRule"
								@keydown.enter.prevent
								@keypress="onKeyPress"
								@input="sanitizeUF"
							></v-text-field>
						</div>
						<!-- <v-textarea
							v-model="formData.description"
							label="Descripción"
							outlined
							dense
							rows="3"
							class="mb-3"
						/> -->
					</v-form>
				</v-card-text>
				<v-card-actions>
					<div style="width: 100%;">
						<v-divider class="my-2"></v-divider>
						<div class="d-flex justify-end align-center" style="gap:10px;">
							<v-btn
								class="mx-2 my-1"
								color="white"
								raised
								@click="dialog = false"
							>
								Cancelar
							</v-btn>
							<v-btn
								class="mx-2 my-1"
								color="#524D4D"
								raised
								dark
								:loading="saving"
								@click="saveMaterial"
							>
								Confirmar
							</v-btn>
						</div>
					</div>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import { getCompanyMaterials, createCompanyMaterial, updateCompanyMaterial, deleteCompanyMaterial } from '@/helpers/api/costs'

export default {
	name: 'CompanyMaterialsConfig',
	props: {
		company: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			materials: [],
			dialog: false,
			saving: false,
			validForm: true,
			editingMaterial: null,
			formData: {
				name: '',
				description: '',
				uf_value: '',
				company_material_id: null,
				company_id: null
			},
			requiredRule: [
				v => !!v || 'Campo requerido'
			],
			loadingMaterials: false
		}
	},
	computed: {
		selectedCompany() {
			return this.$store.state.companies.selectedCompany
		}
	},
	watch: {
		selectedCompany(newValue) {
			if (newValue) {
				this.fetchMaterials()
			}
		}
	},
	mounted() {
		if (this.selectedCompany) {
			this.fetchMaterials()
		}
	},
	methods: {
		async fetchMaterials() {
			if (!this.selectedCompany) return
			
			try {
				this.loadingMaterials = true
				const response = await getCompanyMaterials({
					company_id: this.company?.id || this.selectedCompany.id
				})
				if (response.code === 200) {
					this.materials = response.materials || []
				} else {
					this.materials = []
				}
			} catch (error) {
				console.error('Error al obtener tipos de estructura:', error)
				this.materials = []
			} finally {
				this.loadingMaterials = false
			}
		},
		openModal(material) {
			this.editingMaterial = material
			if (material) {
				this.formData = {
					name: material.name,
					description: material.description,
					uf_value: material.uf_value || '',
					company_material_id: material.id,
					company_id: this.selectedCompany.id
				}
			} else {
				this.formData = {
					name: '',
					description: '',
					uf_value: '',
					company_material_id: null,
					company_id: this.selectedCompany.id
				}
			}
			this.dialog = true
		},
		async saveMaterial() {
			if (!this.$refs.form.validate()) return

			this.saving = true
			try {
				if (this.editingMaterial) {
					// Editar
					await updateCompanyMaterial({
						company_material_id: this.formData.company_material_id,
						name: this.formData.name,
						description: this.formData.description,
						uf_value: this.formData.uf_value || 0
					})
				} else {
					// Crear
					await createCompanyMaterial({
						name: this.formData.name,
						description: this.formData.description,
						uf_value: this.formData.uf_value || 0,
						company_id: this.selectedCompany.id
					})
				}
				this.dialog = false
				this.$refs.form.reset()
				eventBus.$emit('company_materials_updated')
				await this.fetchMaterials()
			} catch (error) {
				console.error('Error al guardar tipo de estructura:', error)
			} finally {
				this.saving = false
			}
		},
		async deleteMaterial(material) {
			if (!confirm(`¿Estás seguro de que deseas eliminar el tipo de estructura "${material.name}"?`)) {
				return
			}

			try {
				await deleteCompanyMaterial({
					company_material_id: material.id
				})
				eventBus.$emit('company_materials_updated')
				await this.fetchMaterials()
			} catch (error) {
				console.error('Error al eliminar tipo de estructura:', error)
			}
		},
		onKeyPress(event){
			if(event.target?.value > 9999999){
				event.preventDefault();
			}
		},
		sanitizeUF() {
			let value = String(this.formData.uf_value)
			const isNegative = value.startsWith('-')
			value = value
				.replace(/[^0-9.]/g, '')
				.replace(/^0+(?=\d)/, '')
			const parts = value.split('.')
			if (parts.length > 2) {
				value = parts[0] + '.' + parts.slice(1).join('')
			}
			if (isNegative && value !== '') {
				value = '-' + value
			}
			this.formData.uf_value = value || '0'
		}
	}
}
</script>

<style scoped>
</style>
